<template>
  <div>
    <label>{{ title }}</label>
    <div class="row form-group2">
      <el-select
        :disabled="disabled"
        :value="value"
        class="col-md-12 select-info"
        size="large"
        @input="emitSelection"
      >
        <el-option
          v-for="option in selects.meanOfCommunication"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectMeanOfCommunication',
  props: ['value', 'title', 'disabled'],
  data() {
    return {
      selects: {
        simple: '',
        meanOfCommunication: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/meanoftelecomEntities`)
        .then(response => {
          this.selects.meanOfCommunication = response.data._embedded.meanoftelecomEntities.map(
            entity => ({
              value: entity.mocId,
              label: entity.mocName,
            }),
          );
        });
    },
    emitSelection(event) {
      const selectedMocName = this.selects.meanOfCommunication.filter(
        moc => moc.value === event,
      )[0].label;

      this.$emit('input', event);
      this.$emit('inputName', selectedMocName);
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
